/**
 * @module: 汇总
 * @author: Yawei Wang
 * @date: 2019-06-03 13:51:28
 */
import * as hybridJs from './jsbridge';
export { hybridJs };
export default {
  // edit,
  window: window,
  hybridJs: hybridJs
};